import { fetchEpisodes } from '@api/services/titles';
import useLoad from '@hooks/useLoad';
import { useIsNewIngest } from '@hooks/useTitlesDataSource';
import { TTitleContext } from '@models/Title';

const useEpisodesQuery = ({ masterId = '', providerIdentifier }: TTitleContext) => {
  const isNewIngest = useIsNewIngest();

  return useLoad(
    () => fetchEpisodes(masterId, providerIdentifier, undefined, isNewIngest),
    [
      'episodes',
      masterId,
      ...(providerIdentifier ? [providerIdentifier] : []),
      ...(isNewIngest ? ['new-ingest'] : []),
    ]
  );
};

export default useEpisodesQuery;
